document.addEventListener("DOMContentLoaded", function() {
  updateBundleSuggestion();
  document.addEventListener("cart:updated", updateBundleSuggestion);
});

// Single E-book variants: After Moses #1, Prodigal #2, Wormwood #3, Virtus #4, Sanctum #5, Evensong #6
var BUNDLE_UPSELL_EBOOK_VARIANTS = ["46263946903772", "46373489770716", "46373499207900", "46359280582876", "46359280681180", "47126894117084"];
// Bundles that suppress the upsell: Complete E-Book Bundle (plus legacy bundle variant, if still in a cart)
var BUNDLE_UPSELL_BUNDLE_VARIANTS = ["47332899160284", "46363966898396"];

function updateBundleSuggestion() {
  let cartItems = document.querySelectorAll(".cart-item");
  let suggestionContainer = document.querySelector(".page-width"); // Move it higher
  let existingSuggestion = document.querySelector(".bundle-suggestion");

  if (existingSuggestion) existingSuggestion.remove();

  let hasEbook = false;
  let hasBundle = false;
  cartItems.forEach(item => {
    let variantInput = item.querySelector("[data-quantity-variant-id]");
    let variantId = variantInput ? String(variantInput.dataset.quantityVariantId) : "";
    if (BUNDLE_UPSELL_EBOOK_VARIANTS.indexOf(variantId) !== -1) hasEbook = true;
    if (BUNDLE_UPSELL_BUNDLE_VARIANTS.indexOf(variantId) !== -1) hasBundle = true;
  });

  if (hasEbook && !hasBundle && suggestionContainer) {
    let suggestion = document.createElement("p");
    suggestion.className = "bundle-suggestion";
    suggestion.style.color = "rgb(var(--color-foreground))";
    suggestion.innerHTML = 'Save $5! Get <a href="/products/after-moses-books-complete-e-book-bundle">all 6 e-books for $25</a> instead of $30!';
    let suggestionLink = suggestion.querySelector("a");
    if (suggestionLink) { suggestionLink.style.color = "inherit"; suggestionLink.style.textDecoration = "underline"; }
    suggestionContainer.insertBefore(suggestion, suggestionContainer.querySelector(".cart__warnings")); // Place before warnings
  }
}
